import AddEditRooms from './AddEditRooms';

export default AddEditRooms;
